<template>
  <div
    class="scrolly-video"
    ref="refRoot"
    :fit="fit"
    :useWebCodecs="useWebCodecs"
    :preload="preload"
  />
</template>

<script setup lang="ts">
// import ScrollyVideo from "scrolly-video/dist/ScrollyVideo.js"

const props = defineProps({
  src: {
    required: true,
  },
  fit: {
    default: "cover", // cover | contain | none
  },
  progress: {
    default: 0,
  },
  transitionSpeed: {
    default: 20,
  },
  useWebCodecs: {
    default: false,
  },
  preload: {
    default: false,
  },
})

const emits = defineEmits(["loaded"])

const refRoot = ref(null)

const scrolly = ref(null)
const init = async function () {
  // console.log("ScrollyVideo.init", props.src)

  let ScrollyVideo = (await import("scrolly-video/dist/ScrollyVideo.js"))
    .default

  destroy()

  scrolly.value = new ScrollyVideo({
    src: props.src,
    scrollyVideoContainer: refRoot.value,
    useWebCodecs: props.useWebCodecs,
    transitionSpeed: props.transitionSpeed,
    frameThreshold: 0.05,
    trackScroll: false,
    full: false,
    cover: false,
    sticky: false,
    onReady: () => {
      // console.log("ScrollyVideo.onReady")
      emits("loaded")
    },
  })

  if (!props.useWebCodecs) {
    const video = scrolly.value.video

    // console.log("ScrollyVideo.readyState", video.readyState)
    if (video.readyState >= 3) {
      emits("loaded")
      return
    }

    video.addEventListener("canplay", () => {
      // console.log("ScrollyVideo.canplay", props.src)
      emits("loaded")
    })
  }
}

const destroy = function () {
  if (scrolly.value) {
    scrolly.value.destroy()
  }
}

onMounted(() => {
  if (props.preload) {
    init()
  } else {
    emits("loaded")
  }
})
// watch(() => props.src, init)
onBeforeUnmount(destroy)
// onUnmounted(destroy)
usePageEnter(() => {
  if (!props.preload) {
    init()
  }
})

const setProgress = function (val, jump = false) {
  if (scrolly.value?.video.readyState === 0 && val > 0) {
    return
  }

  scrolly.value?.setTargetTimePercent(val, jump)
}
watch(
  () => props.progress,
  () => {
    setProgress(props.progress, false)
  }
)

defineExpose({
  setProgress,
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.scrolly-video {
  @include fill;

  :deep(video) {
    @include fill;
  }

  :deep(canvas) {
    height: 100% !important;
    width: 100% !important;

    object-fit: cover;
  }

  &[fit="contain"] {
    :deep(video) {
      object-fit: contain;
    }
  }
  &[fit="cover"] {
    :deep(video) {
      object-fit: cover;
    }
  }
}
</style>
